import * as React from "react";

function SvgImager(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 34 34" fill="none" {...props}>
      <path
        d="M20.542 14.167a.708.708 0 100-1.417.708.708 0 000 1.417zM15.82 9.917a.59.59 0 11-1.182 0 .59.59 0 011.181 0zM12.042 17a.708.708 0 100-1.417.708.708 0 000 1.417zM19.951 22.313a1.18 1.18 0 11-2.36 0 1.18 1.18 0 012.36 0zM11.687 22.903a.59.59 0 100-1.18.59.59 0 000 1.18z"
        fill="#fff"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M29.396 17c0 6.846-5.55 12.396-12.396 12.396-6.846 0-12.396-5.55-12.396-12.396 0-6.846 5.55-12.396 12.396-12.396 6.846 0 12.396 5.55 12.396 12.396zm-5.313-3.542a3.542 3.542 0 11-7.083 0 3.542 3.542 0 017.083 0zM17 9.917a1.77 1.77 0 11-3.542 0 1.77 1.77 0 013.542 0zm-2.833 6.375a2.125 2.125 0 11-4.25 0 2.125 2.125 0 014.25 0zm8.146 6.02a3.542 3.542 0 11-7.084 0 3.542 3.542 0 017.084 0zm-10.625 1.771a1.77 1.77 0 100-3.541 1.77 1.77 0 000 3.541z"
        fill="#fff"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 3.09C0 1.527 1.526 0 3.09 0h27.82C32.473 0 34 1.526 34 3.09v27.82c0 1.564-1.526 3.09-3.09 3.09H3.09C1.527 34 0 32.474 0 30.91V3.09zM31.167 17c0 7.824-6.343 14.167-14.167 14.167S2.833 24.824 2.833 17 9.176 2.833 17 2.833 31.167 9.176 31.167 17z"
        fill="#fff"
      />
    </svg>
  );
}

export default SvgImager;
